// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CheckFiscalDayNotClosedQueryVariables = Types.Exact<{
  ownerCorporateDataId: Types.Scalars['Int']['input'];
  documentType: Types.InputMaybe<Types.InvoiceDocumentTypeDto>;
  invoiceDate: Types.InputMaybe<Types.Scalars['LocalDate']['input']>;
}>;


export type CheckFiscalDayNotClosedQueryResult = { __typename?: 'Query', checkFiscalDayNotClosed: boolean };

export const CheckFiscalDayNotClosedGql = gql`
    query CheckFiscalDayNotClosed($ownerCorporateDataId: Int!, $documentType: InvoiceDocumentTypeDTO, $invoiceDate: LocalDate) {
  checkFiscalDayNotClosed(
    ownerCorporateDataId: $ownerCorporateDataId
    documentType: $documentType
    invoiceDate: $invoiceDate
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckFiscalDayNotClosedInjectable extends Apollo.Query<CheckFiscalDayNotClosedQueryResult, CheckFiscalDayNotClosedQueryVariables> {
    override document = CheckFiscalDayNotClosedGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */